import React, { useContext, useState } from "react";
import cx from "classnames";
import styles from "../scss/DapQuestion.module.scss";
import Icon from "../../common/components/Icon/Icon";
import Button from "../../common/components/Forms/Button/Button";
import Input from "../../common/components/Forms/Input/Input";
import { AdviceControllerContext } from "../providers/DigitalAdviceProvider";
import { IDigitalSubQuestion } from "../interfaces/IDigitalAdviceData";
import DAQuestionFieldImage from "./DAQuestionFieldImage";
import { ISumbitParams } from "./DigitalAdviceQuestion";
import { Form, Formik } from "formik";

interface ISubQuestionCurrency {
    list: IDigitalSubQuestion[];
    onSubmit: (answerList: ISumbitParams[]) => void;
}

const SubQuestionCurrency: React.FC<ISubQuestionCurrency> = (props) => {
    const { list, onSubmit } = props;

    const [disabledBtn, setDisabledBtn] = useState(true);
    const { selectors } = useContext(AdviceControllerContext);

    const handleBtnDisable = (list): void => {
        setDisabledBtn(list.some((i) => !(i.currency >= 0) || i.currency === ""));
    };

    const getlist = (): Array<IDigitalSubQuestion> => {
        return list.reduce((acc, item) => {
            const newObj = {
                ...item,
                currency: ""
            };
            return [...acc, newObj];
        }, []);
    };
    const [currencyList, setCurrencyList] = useState(getlist());

    const changeHandler = (id, value): void => {
        const list = currencyList.map((el) =>
            el.id === id ? { ...el, currency: value } : el
        );
        handleBtnDisable(list);
        setCurrencyList(list);
    };

    const handleOnSubmit = (): void => {
        if (disabledBtn) false;
        setDisabledBtn(true);
        const answerList = currencyList.reduce((acc, item) => {
            const obj = {
                questionId: item.id,
                textValue: item.currency.toString(),
                sessionUserId: selectors.getSessionUserId()
            };
            acc = [...acc, obj];
            return acc;
        }, []);
        onSubmit(answerList);
    };

    return (
        <Formik initialValues={{}} onSubmit={handleOnSubmit}>
            {() => (
                <Form
                    className={cx(
                        styles["field-dependentchild"],
                        styles["field-currency"]
                    )}>
                    <div className={styles["child-dependent"]}>
                        {currencyList.map((opt, idx) => (
                            <div
                                className={cx(styles["create-child"], {
                                    [styles["custom-currency"]]: opt.placeholder.trim()
                                })}
                                key={idx}>
                                {opt.imgUrl.trim() && !opt.placeholder.trim() && (
                                    <div className={styles["img-container"]}>
                                        <DAQuestionFieldImage imgUrl={opt.imgUrl} />
                                    </div>
                                )}
                                <div className={styles["custom-currency--label"]}>
                                    <label>{opt.label}</label>
                                    {opt.placeholder.trim() && (
                                        <span>{opt.placeholder}</span>
                                    )}
                                </div>
                                <div className={styles["custom-currency--input"]}>
                                    <Input
                                        name="comtrolTypeNumber"
                                        type="number"
                                        hasCurrency={true}
                                        value={opt.currency}
                                        onChange={(e) => {
                                            changeHandler(opt.id, e);
                                        }}></Input>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className={styles.buttonNext}>
                        <Button
                            className={cx("get-started")}
                            width="content"
                            component="button"
                            size="m"
                            type="submit"
                            isDisabled={disabledBtn}
                            variant="calltoaction">
                            <span>Next</span>
                        </Button>
                    </div>
                </Form>
            )}
        </Formik>
    );
};

export default SubQuestionCurrency;
